import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function FinishRouteIcon({
  color = RoutalPalette.primary40,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15" style={{ width: `15px`, height: `15px`, ...props.style }}>
      <g fill="none">
        <path
          id="Vector"
          d="M2.85059 9.55664C2.85059 9.55664 3.45362 8.9536 5.26273 8.9536C7.07184 8.9536 8.27791 10.1597 10.087 10.1597C11.8961 10.1597 12.4992 9.55664 12.4992 9.55664V2.3202C12.4992 2.3202 11.8961 2.92324 10.087 2.92324C8.27791 2.92324 7.07184 1.71716 5.26273 1.71716C3.45362 1.71716 2.85059 2.3202 2.85059 2.3202V9.55664Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path id="Vector_2" d="M2.85059 13.7779V9.55664" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <rect id="Rectangle 771" x="3.07031" y="1.95251" width="2.3751" height="2.3751" fill={color} />
        <rect id="Rectangle 772" x="5.44531" y="4.32751" width="2.3751" height="2.3751" fill={color} />
        <rect id="Rectangle 777" x="3.07031" y="6.70264" width="2.3751" height="2.3751" fill={color} />
        <path id="Rectangle 775" d="M7.82031 2.19531L10.1954 2.9585V4.32755H7.82031V2.19531Z" fill={color} />
        <rect id="Rectangle 776" x="10.1958" y="4.32751" width="2.3751" height="2.3751" fill={color} />
        <rect id="Rectangle 773" x="7.82031" y="6.70264" width="2.3751" height="2.3751" fill={color} />
        <path
          id="Rectangle 778"
          d="M5.44531 8.87207L7.82041 9.07776L7.82041 9.8035L5.44531 9.05835V8.87207Z"
          fill={color}
        />
        <path id="Rectangle 774" d="M10.1954 9.07776H12.5705V9.67931L10.1953 10.1761L10.1954 9.07776Z" fill={color} />
      </g>
    </SvgIcon>
  );
}
